import React, { useEffect, useState, useContext } from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { GetCustomerProfile, authLogin } from "services/Api/Module/Auth";
import helper from "services/helper";
import PageHeader from "components/PageHeader";
import ModalContext from "contexts/ModalContext";

const Login = () => {
  const { mAlert } = useContext(ModalContext);

  const [ username, setUsername] = useState("")
  const [ password, setPassword] = useState("")
  const navigate = useNavigate();

  const postLogin = async (payload) => {
    try {
      const response = await authLogin({ data: payload })
      const resData = response.data
      console.log("🚀 ~ authLogin ~ resData:", resData)
      // const resData = await getCustomerProfile()
      if (resData.resultCode === 20000) {
        helper.Auth.setToken(resData.resultData)
        navigate('/login-complete')
      }
      else if (resData.resultCode === 40101) {
        mAlert.info({
          title: "แจ้งเตือน",
          subTitle: "คุณได้ทำการเข้าสู่ระบบในอุปกรณ์อื่นแล้ว",
          content: "",
          onClose: () => {},
        })
      } else {
        mAlert.info({
          title: "แจ้งเตือน",
          subTitle: "ไม่พบข้อมูล",
          content: "",
          onClose: () => {},
        })
      }
    }
    catch (err) {
      console.log('err ', err)
      mAlert.info({
        title: "แจ้งเตือน",
        subTitle: "มีบางอย่างผิดพลาด",
        content: "",
        onClose: () => {},
      })
    }
  }
  
  const onSubmit = (e) => {
    e.preventDefault();
    const payload = { username: username, password: password };
    console.log('payload >>', payload)
    postLogin(payload)
  }

  useEffect(() => {}, []);

  return (
    <div>
      <Helmet>
        <title></title>
        <meta name="title" content="" />
        <meta name="description" content="" />
        <meta name="keyword" content="" />
        <meta property="og:title" content="" />
        <meta property="og:description" content="" />
        <meta property="og:image" content="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="" />
      </Helmet>
      <div id="pageRestaurant-login">

        {/* <!-- Page Header --> */}
        <PageHeader title="เข้าสู่ระบบร้านค้า" notClose={true} onBack={() => navigate("/profile")}/>

        {/* <!-- Content Page --> */}
        <main id="top">
          <div className="wrapContent">
            <section id="pRegister">
              <div className="bRegisterMain">
                <form>
                  <div className="bForm">
                    <h2>เข้าสู่ระบบร้านค้า</h2>
                    <div className="bGroup">
                      <div className="bRow">
                        <div className="control-group">
                          <div className="inputPlaceholder">
                            <span>บัญชีผู้ใช้</span>
                            <input
                              type="text"
                              name="text"
                              value={username}
                              onInput={helper.FNFORM.handleCharOnly}
                              onChange={(e) => setUsername(e.target.value)}
                              maxLength={100}
                              placeholder="บัญชีผู้ใช้"
                            />
                          </div>
                          <label for="" className="tError">Text Error Input</label>
                        </div>
                      </div>
                      <div className="bRow">
                        <div className="control-group">
                          <div className="inputPlaceholder">
                            <span>รหัสผ่าน</span>
                            <input 
                              type="password" 
                              name="text"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)} 
                              maxLength={100}
                              placeholder="รหัสผ่าน" 
                            />
                          </div>
                          <label for="" className="tError">Text Error Input</label>
                        </div>
                      </div>
                    </div>
                    <div className="bBtn">
                      <button className="btn" onClick={onSubmit}>เข้าสู่ระบบ</button>
                    </div>
                  </div>                
                </form>
              </div>
            </section>
          </div>
        </main>

      </div>
    </div>
  );
};

export default Login;
